import type { NotificationSeverity } from './Notification'

export type ToastAction = Readonly<{ label: string, onClick: () => void }>

export type ToastItem = Readonly<{
    id: string
    severity: NotificationSeverity
    title: string
    description?: string
    action?: ToastAction
    /** How many times this toast (matched by `dedupeKey`) has fired while still visible. */
    count: number
    /** When true, never auto-dismisses - the caller is fully responsible for calling `dismiss()`. */
    persist?: boolean
}>

export type ToastsAppState = Readonly<{ toasts: ReadonlyArray<ToastItem> }>

export const selectToasts = (s: ToastsAppState): ToastsAppState['toasts'] => s.toasts
